import { useMemo } from "react";
import VideoJS from "../VideoJS";
import { LiveViewModel } from "../../models/LiveViewModel";
import { Button } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiWhatsapp } from "@mdi/js";
import { useToast } from "../../context/ToastContext";

type LiveCardProps = {
	data?: LiveViewModel;
	liveUrl?: string;
	onClick: () => void;
};

export default function LiveCard(props: LiveCardProps) {
	const { handleToast } = useToast();

	const videoJsOption = useMemo(() => {
		return {
			autoplay: true,
			playsinline: true,
			controls: false,
			muted: true,
			responsive: true,
			fill: true,
			sources: props.data?.parametro.liveURL || props.liveUrl,
			poster: process.env.PUBLIC_URL + "/logo_escuro.png",
			language: "pt",
			languages: {
				pt: {
					"The media could not be loaded, either because the server or network failed or because the format is not supported.":
						"O vídeo não pôde ser carregado. O servidor falhou, a rede caiu ou o formato não é suportado.",
				},
			},
		};
	}, [props.data?.parametro.liveURL, props.liveUrl]);

	function handleWhatsapp() {
		if (props.data?.parametro.whatsAppLiveURL) {
			navigator.clipboard.writeText(props.data.parametro.whatsAppLiveURL);
			handleToast("Live", "Link da Live copiado para a área de transferência.", 5000);
		}
	}

	return (
		<div className="position-relative d-flex justify-content-center rounded-3 shadow overflow-hidden" style={{ width: "100%", height: "100%" }}>
			{props.data && (
				<>
					<div
						className="position-absolute fs-6 text-white p-2 lh-1 rounded"
						style={{ zIndex: 10, top: 10, background: "rgba(31, 37, 60, 0.5)", backdropFilter: "blur(5px)", cursor: "pointer" }}
						onClick={props.onClick}
					>
						{props.data.cliente && `${props.data.cliente.nome} - `}
						{props.data.drone.nome}
					</div>
					<Button variant="air-dark" className="d-flex align-items-center position-absolute" onClick={handleWhatsapp} style={{ zIndex: 10, top: 10, right: 10 }}>
						<Icon path={mdiWhatsapp} size={1} />
					</Button>
					<div
						className="position-absolute d-flex flex-wrap justify-content-center gap-2 fs-6 text-white p-2 lh-1 rounded"
						style={{ zIndex: 10, bottom: 10, background: "rgba(31, 37, 60, 0.5)", backdropFilter: "blur(5px)" }}
					>
						<div className="small">
							<span className="fw-lighter">Altura:</span> {props.data.altura.toFixed(2)} <span className="small">m</span>
						</div>
						<div className="small">
							<span className="fw-lighter">Velocidade:</span> {props.data.velocidade.toFixed(2)} <span className="small">m/s</span>
						</div>
						<div className="small">
							<span className="fw-lighter">GPS:</span> {props.data.gpsSignal} <span className="small">/5</span> ({props.data.gpsCount})
						</div>
					</div>
				</>
			)}
			<VideoJS options={videoJsOption} reconnect={!!props.liveUrl} className="bg-dark" style={{ width: "100%", height: "100%" }} />
		</div>
	);
}
